import { memo } from 'react';

import { Flex } from '@/components/core';
import { ActionRunTest, HttpHeaders, HttpUrl } from '@/components/flow';

export type ExportMakeConfigurationProps = object;

// eslint-disable-next-line no-empty-pattern
const IExportMakeConfiguration = ({}: ExportMakeConfigurationProps = {}) => {
  return (
    <Flex col className="gap-md p-md">
      <HttpUrl placeholder="https://hook.eu2.make.com/..." />
      <HttpHeaders />
      <ActionRunTest />
    </Flex>
  );
};

export const ExportMakeConfiguration = memo(IExportMakeConfiguration) as typeof IExportMakeConfiguration;
